module.exports=[
  {
    "id": 8752,
    "first": "Joe",
    "last": "Biden",
    "show": true,
    "show_on_delegate_tracker": true,
    "dropped_out": false
  },
  {
    "id": 8758,
    "first": "Michael",
    "last": "Bloomberg",
    "show": false,
    "show_on_delegate_tracker": true,
    "dropped_out": true
  },
  {
    "id": 8750,
    "first": "Tulsi",
    "last": "Gabbard",
    "show": true,
    "show_on_delegate_tracker": true,
    "dropped_out": false
  },
  {
    "id": 8751,
    "first": "Bernie",
    "last": "Sanders",
    "show": true,
    "show_on_delegate_tracker": true,
    "dropped_out": false
  },
  {
    "id": 8757,
    "first": "Elizabeth",
    "last": "Warren",
    "show": false,
    "show_on_delegate_tracker": true,
    "dropped_out": true
  },
  {
    "id": 8766,
    "first": "Michael",
    "last": "Bennet",
    "show": false,
    "show_on_delegate_tracker": false,
    "dropped_out": true
  },
  {
    "id": 8753,
    "first": "Cory",
    "last": "Booker",
    "show": false,
    "show_on_delegate_tracker": false,
    "dropped_out": true
  },
  {
    "id": 8754,
    "first": "Pete",
    "last": "Buttigieg",
    "show": false,
    "show_on_delegate_tracker": true,
    "dropped_out": true
  },
  {
    "id": 8765,
    "first": "John",
    "last": "Delaney",
    "show": false,
    "show_on_delegate_tracker": false,
    "dropped_out": true
  },
  {
    "id": 8749,
    "first": "Amy",
    "last": "Klobuchar",
    "show": false,
    "show_on_delegate_tracker": true,
    "dropped_out": true
  },
  {
    "id": 8759,
    "first": "Deval",
    "last": "Patrick",
    "show": false,
    "show_on_delegate_tracker": false,
    "dropped_out": true
  },
  {
    "id": 8755,
    "first": "Tom",
    "last": "Steyer",
    "show": false,
    "show_on_delegate_tracker": false,
    "dropped_out": true
  },
  {
    "id": 8756,
    "first": "Andrew",
    "last": "Yang",
    "show": false,
    "show_on_delegate_tracker": false,
    "dropped_out": true
  },
  {
    "id": 8767,
    "first": "",
    "last": "Uncommitted",
    "show": false,
    "show_on_delegate_tracker": false,
    "dropped_out": false
  }
]